export const APACHE_SPARK_LABEL_SELECTOR_ANNOTATION =
  'apache-spark.cnoe.io/label-selector';
export const CLUSTER_NAME_ANNOTATION = 'apache-spark.cnoe.io/cluster-name';
export const K8S_NAMESPACE_ANNOTATION = 'backstage.io/kubernetes-namespace';
